const headerElement = document.getElementById("header");

if (headerElement) {
  let headerHeight = headerElement.offsetHeight;
  let lastScroll = headerHeight;

  headerElement.style.top = "0px";

  // We wait one second to make sure the header has been rendered and the user has scrolled.
  setTimeout(() => {
    let headerState;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const height = entry.contentRect.height;
        if (typeof height === "number" && height !== headerHeight) {
          headerHeight = height;
        }
      }
    });

    resizeObserver.observe(headerElement); // Watch for height changes of navbar.

    let waiting = false;

    function handleScroll() {
      let currentScroll = window.scrollY;

      if (currentScroll <= headerHeight) {
        waiting = false;
        return;
      }

      if (currentScroll < lastScroll) {
        if (headerState != "up") {
          headerElement.dispatchEvent(
            new CustomEvent("header-toggled", {
              detail: {
                state: "up",
                top: 0,
              },
              bubbles: false,
            })
          );
        }
      } else {
        if (headerState != "down") {
          headerElement.dispatchEvent(
            new CustomEvent("header-toggled", {
              detail: {
                state: "down",
                top: headerHeight,
              },
              bubbles: false,
            })
          );
        }
      }

      lastScroll = currentScroll;
      waiting = false;
    }

    headerElement.addEventListener("header-toggled", handleHeaderToggled);

    function handleHeaderToggled(e) {
      const { state, top } = e.detail;
      headerElement.style.left = 0;
      headerElement.style.right = 0;
      headerElement.style.top = `-${top}px`;
      headerState = state;

      if (document.querySelector(".js-select-dropdown-hide-on-scroll")) {
        headerElement.click(); // Simulate a click event to trigger dropdown functions to hide the dropdown.
      }
    }

    function requestHeaderChange() {
      if (!waiting) {
        requestAnimationFrame(handleScroll);
        waiting = true;
      }
    }

    window.addEventListener("scroll", requestHeaderChange, { passive: true });
  }, 1000);
}
